export default "__VITE_ASSET__BRLd67aT__"